"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyboardImplementation = keyboardImplementation;
exports.releaseAllKeys = releaseAllKeys;

var _dom = require("@testing-library/dom");

var _utils = require("../utils");

var _getNextKeyDef = require("./getNextKeyDef");

var plugins = _interopRequireWildcard(require("./plugins"));

var _getEventProps = require("./getEventProps");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function keyboardImplementation(_x, _x2, _x3) {
  return _keyboardImplementation.apply(this, arguments);
}

function _keyboardImplementation() {
  _keyboardImplementation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text, options, state) {
    var _state$repeatKey, document, getCurrentElement, _ref, keyDef, consumedLength, releasePrevious, releaseSelf, repeat, replace, pressed, unpreventedDefault;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            document = options.document;

            getCurrentElement = function getCurrentElement() {
              return getActive(document);
            };

            _ref = (_state$repeatKey = state.repeatKey) != null ? _state$repeatKey : (0, _getNextKeyDef.getNextKeyDef)(text, options), keyDef = _ref.keyDef, consumedLength = _ref.consumedLength, releasePrevious = _ref.releasePrevious, releaseSelf = _ref.releaseSelf, repeat = _ref.repeat;
            replace = applyPlugins(plugins.replaceBehavior, keyDef, getCurrentElement(), options, state);

            if (!replace) {
              pressed = state.pressed.find(function (p) {
                return p.keyDef === keyDef;
              }); // Release the key automatically if it was pressed before.
              // Do not release the key on iterations on `state.repeatKey`.

              if (pressed && !state.repeatKey) {
                keyup(keyDef, getCurrentElement, options, state, pressed.unpreventedDefault);
              }

              if (!releasePrevious) {
                unpreventedDefault = keydown(keyDef, getCurrentElement, options, state);

                if (unpreventedDefault && hasKeyPress(keyDef, state)) {
                  keypress(keyDef, getCurrentElement, options, state);
                } // Release the key only on the last iteration on `state.repeatKey`.


                if (releaseSelf && repeat <= 1) {
                  keyup(keyDef, getCurrentElement, options, state, unpreventedDefault);
                }
              }
            }

            if (repeat > 1) {
              state.repeatKey = {
                // don't consume again on the next iteration
                consumedLength: 0,
                keyDef: keyDef,
                releasePrevious: releasePrevious,
                releaseSelf: releaseSelf,
                repeat: repeat - 1
              };
            } else {
              delete state.repeatKey;
            }

            if (!(text.length > consumedLength || repeat > 1)) {
              _context.next = 11;
              break;
            }

            if (!(options.delay > 0)) {
              _context.next = 10;
              break;
            }

            _context.next = 10;
            return (0, _utils.wait)(options.delay);

          case 10:
            return _context.abrupt("return", keyboardImplementation(text.slice(consumedLength), options, state));

          case 11:
            return _context.abrupt("return", void undefined);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _keyboardImplementation.apply(this, arguments);
}

function getActive(document) {
  var _getActiveElement;

  return (_getActiveElement = (0, _utils.getActiveElement)(document)) != null ? _getActiveElement :
  /* istanbul ignore next */
  document.body;
}

function releaseAllKeys(options, state) {
  var getCurrentElement = function getCurrentElement() {
    return getActive(options.document);
  };

  var _iterator = _createForOfIteratorHelper(state.pressed),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var k = _step.value;
      keyup(k.keyDef, getCurrentElement, options, state, k.unpreventedDefault);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function keydown(keyDef, getCurrentElement, options, state) {
  var element = getCurrentElement(); // clear carried characters when focus is moved

  if (element !== state.activeElement) {
    state.carryValue = undefined;
    state.carryChar = '';
  }

  state.activeElement = element;
  applyPlugins(plugins.preKeydownBehavior, keyDef, element, options, state);

  var unpreventedDefault = _dom.fireEvent.keyDown(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));

  state.pressed.push({
    keyDef: keyDef,
    unpreventedDefault: unpreventedDefault
  });

  if (unpreventedDefault) {
    // all default behavior like keypress/submit etc is applied to the currentElement
    applyPlugins(plugins.keydownBehavior, keyDef, getCurrentElement(), options, state);
  }

  return unpreventedDefault;
}

function keypress(keyDef, getCurrentElement, options, state) {
  var element = getCurrentElement();

  var unpreventedDefault = _dom.fireEvent.keyPress(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));

  if (unpreventedDefault) {
    applyPlugins(plugins.keypressBehavior, keyDef, getCurrentElement(), options, state);
  }
}

function keyup(keyDef, getCurrentElement, options, state, unprevented) {
  var element = getCurrentElement();
  applyPlugins(plugins.preKeyupBehavior, keyDef, element, options, state);

  var unpreventedDefault = _dom.fireEvent.keyUp(element, (0, _getEventProps.getKeyEventProps)(keyDef, state));

  if (unprevented && unpreventedDefault) {
    applyPlugins(plugins.keyupBehavior, keyDef, getCurrentElement(), options, state);
  }

  state.pressed = state.pressed.filter(function (k) {
    return k.keyDef !== keyDef;
  });
  applyPlugins(plugins.postKeyupBehavior, keyDef, element, options, state);
}

function applyPlugins(pluginCollection, keyDef, element, options, state) {
  var plugin = pluginCollection.find(function (p) {
    return p.matches(keyDef, element, options, state);
  });

  if (plugin) {
    plugin.handle(keyDef, element, options, state);
  }

  return !!plugin;
}

function hasKeyPress(keyDef, state) {
  var _keyDef$key;

  return (((_keyDef$key = keyDef.key) == null ? void 0 : _keyDef$key.length) === 1 || keyDef.key === 'Enter') && !state.modifiers.ctrl && !state.modifiers.alt;
}